// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1zSJH","ranges":"BmiRanges_ranges__3R90x"};